<template>
  <v-dialog v-model="dialog" width="800px" :fullscreen="$vuetify.breakpoint.smAndDown" scrollable>
    <BaseBodyDialog title="Thêm lớp học" @close="cancel" @save="save">
      <v-divider></v-divider>
      <ClassNewForm ref="form" :classData="{}" :major="major" :course="course" />
    </BaseBodyDialog>
  </v-dialog>
</template>

<script>
import ClassNewForm from '@/components/basic/form/ClassNewForm.vue'
import BaseBodyDialog from '@/components/basic/dialog/BaseBodyDialog.vue'
import { mapActions, mapGetters } from 'vuex'
import { Class } from '@/plugins/api'
import get from 'lodash-es/get'

export default {
  components: {
    ClassNewForm,
    BaseBodyDialog
  },
  props: {
    state: Boolean,
    major: Object,
    course: Object,
  },
  data() {
    return {
      dialog: false,
    }
  },
  computed: {
    ...mapGetters('class', ['classes']),
  },
  methods: {
    ...mapActions('class', ['createClass']),
    async save() {
      if (!this.$refs.form.validate()) return

      const data = this.$refs.form.getData()
      if (await Class.count({ title: data.title })) {
        this.$alert.error('Tên lớp đã tồn tại')
        return
      }
      let classData = {}
      try {
        this.$loading.active = true
        classData = await this.createClass({
          ...data,
          status: 'running',
          type: 'coreCurriculum',
        })
        this.$alert.addSuccess()
        // this.$refs.form.reset()
        this.dialog = false
        this.$emit('done', classData)
      } catch (error) {
        this.$alert.addError(error)
        await Class.remove(get(classData, 'id'))
      } finally {
        this.$loading.active = false
      }
    },
    cancel() {
      this.$refs.form.reset()
      this.dialog = false
    },
  },

  watch: {
    state() {
      this.dialog = true
    },
  },
}
</script>
